var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "message-screen",
      style: { backgroundColor: _vm.theme.screenBackgroundColor.value },
    },
    [
      _c(
        "header",
        {
          staticClass: "header",
          style: { backgroundColor: _vm.theme.headerBackgroundColor.value },
        },
        [
          _c(
            "h1",
            {
              staticClass: "header-title",
              style: { color: _vm.theme.headerTextColor.value },
            },
            [_vm._v(_vm._s(this.$props.venue.venue_name))]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "message-list" },
        _vm._l(_vm.messages, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "message-item",
              style: { backgroundColor: _vm.theme.displayInfoBackground.value },
            },
            [
              _c(
                "div",
                {
                  staticClass: "icon-box",
                  style: { backgroundColor: _vm.theme.infoIconColor.value },
                },
                [_c("span", { staticClass: "icon" }, [_vm._v("💬")])]
              ),
              _c("div", { staticClass: "message-content" }, [
                _c(
                  "h3",
                  {
                    staticClass: "msg-title",
                    style: { color: _vm.theme.PrimaryTextColor.value },
                  },
                  [_vm._v(_vm._s(item.title))]
                ),
                _c(
                  "p",
                  {
                    staticClass: "msg-subtitle",
                    style: { color: _vm.theme.SecondaryTextColor.value },
                  },
                  [_vm._v(_vm._s(item.subtitle))]
                ),
              ]),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }